import {
  ALL_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_NEW_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_VEHICLES_LISTING_SECTION_ID,
  CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_NEW_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_VEHICLES_LISTING_SECTION_ID,
  NEW_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_NEW_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_ID,
  SECOND_HAND_VEHICLES_LISTING_SECTION_ID
} from '../common/listingSections.js'
import {
  BUGGIES_CATEGORY1_ID,
  CLASSIC_MOTOS_CATEGORY1_ID,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  QUADS_CATEGORY1_ID
} from './vehicleSpecifications/categories.js'
import {OFFER_TYPE_NEW, OFFER_TYPE_SECOND_HAND} from './search.js'

export const LISTING_SECTION_IDS_BY_CATEGORIES = {
  [BUGGIES_CATEGORY1_ID]: BUGGIES_VEHICLES_LISTING_SECTION_ID,
  [CLASSIC_MOTOS_CATEGORY1_ID]: CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID,
  [MINIMOTOS_CATEGORY1_ID]: MINIMOTOS_VEHICLES_LISTING_SECTION_ID,
  [MOTOS_CATEGORY1_ID]: ALL_VEHICLES_LISTING_SECTION_ID,
  [QUADS_CATEGORY1_ID]: QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_ID
}

export const LISTING_SECTION_IDS_BY_CATEGORIES_AND_OFFER_TYPES = {
  [BUGGIES_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: BUGGIES_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: BUGGIES_NEW_VEHICLES_LISTING_SECTION_ID
  },
  [CLASSIC_MOTOS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID
  },
  [MINIMOTOS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: MINIMOTOS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: MINIMOTOS_NEW_VEHICLES_LISTING_SECTION_ID
  },
  [MOTOS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: NEW_VEHICLES_LISTING_SECTION_ID
  },
  [QUADS_CATEGORY1_ID]: {
    [OFFER_TYPE_SECOND_HAND]: QUADS_AND_ATVS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
    [OFFER_TYPE_NEW]: QUADS_AND_ATVS_NEW_VEHICLES_LISTING_SECTION_ID
  }
}
